module.exports = require("@zendeskgarden/react-utilities");